<template>
  <div class="submit-container" v-if="start">
    <p>Submit selected lineup changes to production</p>
    <div class="submit-actions">
      <button class="mds-button" type="button" @click="closeModal">
        Cancel
      </button>
      <mds-button variation="primary" class="submit-button" @click="doSubmit"> Submit to Production </mds-button>
    </div>
  </div>
  <div class="submit-container progress" v-else>
    <mds-loader />
    <p class="submit-process-text">Submitting to Production</p>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
/* eslint import/no-cycle: [2, { maxDepth: 1 }] */
import * as LineupsFundsService from '@/services/LineupsFunds';

export default {
  name: 'submit-changes',
  props: {
    data: {
      type: Object,
      default() {
        return {
          funds: [],
          count: 0,
        };
      },
    },
  },
  data() {
    return {
      start: true,
    };
  },
  computed: {
    ...mapState({
      fiduciary: (state) => state.user.fiduciary.id,
    }),
  },
  methods: {
    ...mapActions({
      closeModal: 'closeModal',
    }),
    doSubmit() {
      this.start = false;
      const payload = this.data.funds;
      LineupsFundsService.submitFiduciaryLineupsChanges({
        fiduciary: this.fiduciary,
        payload,
      }).then((result) => {
        if (result.status.success) {
          // force the grid to reload
          this.$store.dispatch('setReloadNeed', true);
          this.$store.dispatch('openNotification', {
            title: 'Lineups Successfully Submitted',
            message: `${this.data.count} ${
              this.data.count > 1 ? 'lineups have' : 'lineup has'
            } been submitted to production`,
          });
        }
      }).catch((error) => {
        const httpStatus = (error?.response.status) ? (error?.response.status) : (error?.status);
        if (httpStatus === 401) {
          this.$router.push('/Login');
        }
      }).finally(() => {
        this.closeModal();
      });
    },
  },
};
</script>
<style lang="scss">
.submit-container {
  @include mds-body-text-m();
  .submit-process-text {
    text-align: center;
  }
}
</style>
